import Email from "../../../logic/models/Email";
import { IJSONOutEmail } from "../../jsons/out/JSONOutEmail";

export class EmailJSONMappingService { 


  //#region emailToJSON
  public static mapEmailToNewJson(email: Email): IJSONOutEmail {
    let json: IJSONOutEmail = {}

    //if (email.recipient != null) { try { json.recipient = email.recipient!!; } catch(e) {} }
    
    if (email.senderNameDirty != null) { try { json.senderName = email.senderNameDirty!!; } catch(e) {} }
    if (email.senderDirty != null) { try { json.sender = email.senderDirty!!; } catch(e) {} }

    if (email.subjectDirty != null) { try { json.subject = email.subjectDirty!!; } catch(e) {} }
    if (email.messageDirty != null) { try { json.message = email.messageDirty!!; } catch(e) {} }

    return json;
  }
  //#endregion
}